import {styled} from "styled-components";

export const FilterContainer = styled.div`
  margin-left: auto;
`;
